import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ResizeObserver } from '@juggle/resize-observer';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { getAggregation } from '@collections/aggregations';
import { Subpages } from '@modules/job-page/containers/page/model/subpages';
import { getDirectApplicantsPerPhaseNumbers } from '@modules/job-page/store';
import { AggregatedJobData } from '@shared/models';
import { DirectApplicantsPerPhaseNumber } from '@shared/models/direct-applicants-per-phase-number';
import { HMStatuses } from '@modules/assigns/components/job-assign-collection-header/job-assign-collection-header.component';
@Component({
  selector: 'mojo-shared-job-matches-phases',
  templateUrl: './matches-phases.component.html',
  styleUrls: ['./matches-phases.component.scss'],
})
export class MatchesPhasesComponent implements AfterViewInit, OnDestroy {
  private readonly phaseElementMinWidth = 120;
  readonly carouselHeight = 68;
  readonly carouselElementMargin = 16;
  readonly directApplicantsLabel = 'Total direct applicants';
  statuses: HMStatuses = {
    hmStatus: [],
    statuses: [],
  };
  @ViewChild('carouselContainer', { static: false, read: ElementRef })
  carouselContainer: ElementRef;

  _jobId: number;
  shortlist = Subpages.SHORTLIST;

  @Input() enableLinks = true;
  @Input() set jobId(jobId: number) {
    this._jobId = jobId;
    this.directApplicantsTotal$ = this.store
      .select(getAggregation, { jobId, anonymize: false })
      .pipe(map((aggregations: AggregatedJobData) => aggregations?.totalDirect || 0));
  }
  @Output() statusesChange = new EventEmitter();

  carouselResizeObserver: ResizeObserver;
  showCarousel = false;
  phasesInView;

  private carouselContainerWidth$ = new Subject<number>();
  private subs = new Subscription();
  phases$: Observable<DirectApplicantsPerPhaseNumber[]> = this.store.select(
    getDirectApplicantsPerPhaseNumbers,
  );
  directApplicantsTotal$: Observable<number>;

  constructor(private cdf: ChangeDetectorRef, private store: Store<{}>) {}

  ngAfterViewInit() {
    const ro = new ResizeObserver(() => {
      this.carouselContainerWidth$.next(this.carouselContainer.nativeElement.offsetWidth);
    });
    ro.observe(this.carouselContainer.nativeElement);
    this.subs.add(
      this.carouselContainerWidth$
        .pipe(distinctUntilChanged(), debounceTime(100))
        .subscribe((carouselWidth) => this.recalculatePhasesInView(carouselWidth)),
    );
  }

  ngOnDestroy() {
    this.carouselResizeObserver?.disconnect();
    this.subs?.unsubscribe();
  }

  getShortlistedParams(phaseName: string) {
    const filterArr: string[] = [];
    filterArr.push(phaseName);
    return { shortlistedFilters: JSON.stringify(filterArr) };
  }

  private recalculatePhasesInView(carouselWidth) {
    this.phasesInView = Math.floor(carouselWidth / this.phaseElementMinWidth);
    this.reloadCarousel();
  }

  private reloadCarousel() {
    // Workaround for issue with carousel: https://github.com/ivylaboratory/angular-carousel/issues/87
    this.changeCarouselVisibility(false);
    setTimeout(() => this.changeCarouselVisibility(true));
  }

  private changeCarouselVisibility(carouselVisibility: boolean) {
    this.showCarousel = carouselVisibility;
    this.cdf.detectChanges();
  }

  changeStatus(phaseName: string) {
    if (phaseName === this.directApplicantsLabel) {
      return;
    }
    this.statuses.statuses.push(phaseName);
    this.statusesChange.emit(this.statuses);
  }
}
